document.addEventListener('DOMContentLoaded', function () {
  var blogSection = document.querySelector('.shopify-section__blog');
  if (!blogSection) return;

  var container = blogSection.querySelector('.container');
  if (!container) return;

  /* ── 1. Inject masthead ── */
  var masthead = document.createElement('div');
  masthead.className = 'abc-mag-masthead';
  masthead.style.position = 'relative';
  masthead.style.overflow = 'hidden';
  masthead.innerHTML =
    '<canvas class="abc-mag-canvas" aria-hidden="true" style="position:absolute;inset:0;width:100%;height:100%;pointer-events:none;"></canvas>' +
    '<div style="position:relative;z-index:1;text-align:center;">' +
      '<div class="abc-mag-ornament">&#10022; &nbsp; &#10022; &nbsp; &#10022;</div>' +
      '<p class="abc-mag-genre">Science Fiction &nbsp;&#8727;&nbsp; Dark Fantasy &nbsp;&#8727;&nbsp; Horror</p>' +
      '<h1 class="abc-mag-title">APEX MAGAZINE</h1>' +
      '<p class="abc-mag-tagline">Strange. Surreal. Shocking. Beautiful.</p>' +
      '<p class="abc-mag-editor">Edited by Lesley Conner</p>' +
      '<div aria-hidden="true" style="display:block;width:60%;height:2px;margin:1.5rem auto 1.25rem;background:linear-gradient(to right,transparent,#7a5c2a 20%,#c9a84c 50%,#7a5c2a 80%,transparent);"></div>' +
      '<p class="abc-mag-issue">Issue 153 &nbsp;&#8727;&nbsp; Cover art by Valentina Paz &nbsp;&#8727;&nbsp; Cover design by Justin Stewart</p>' +
    '</div>';

  /* Insert masthead before breadcrumbs; leave breadcrumbs in body */
  var breadcrumbs = container.querySelector('.breadcrumbs');
  if (breadcrumbs) {
    container.insertBefore(masthead, breadcrumbs);
    /* Style breadcrumbs as body-level literary nav */
    breadcrumbs.classList.add('abc-mag-breadcrumb-body');
  } else {
    container.insertBefore(masthead, container.firstChild);
  }

  /* ── 2. Constellation canvas animation ── */
  var canvas = masthead.querySelector('.abc-mag-canvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var particles = [];
    var COUNT = 60;
    var MAX_DIST = 120;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initParticles() {
      particles = [];
      for (var i = 0; i < COUNT; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.4,
          vy: (Math.random() - 0.5) * 0.4,
          r: Math.random() * 1.2 + 0.4
        });
      }
    }

    function drawFrame() {
      canvas.width = masthead.offsetWidth;
      canvas.height = masthead.offsetHeight;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var a = 0; a < particles.length; a++) {
        var p = particles[a];
        if (!reduced) { p.x += p.vx; p.y += p.vy; }
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        for (var b = a + 1; b < particles.length; b++) {
          var q = particles[b];
          var d = Math.hypot(p.x - q.x, p.y - q.y);
          if (d < MAX_DIST) {
            ctx.strokeStyle = 'rgba(201,168,76,' + (0.18 * (1 - d / MAX_DIST)) + ')';
            ctx.lineWidth = 0.6;
            ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); ctx.stroke();
          }
        }
        ctx.fillStyle = 'rgba(255,255,255,' + (0.5 + p.r * 0.3) + ')';
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      }
      if (!reduced) requestAnimationFrame(drawFrame);
    }

    canvas.width = masthead.offsetWidth;
    canvas.height = masthead.offsetHeight;
    initParticles();
    if (typeof requestAnimationFrame !== 'undefined') drawFrame();
  }

  /* ── 3a. Inject font-size overrides via stylesheet (beats Magefan !important) ── */
  var styleTag = document.createElement('style');
  styleTag.textContent = [
    '.shopify-section__blog .article-post__data-wrap { font-size: 1.4rem !important; font-family: "EB Garamond", Georgia, serif !important; font-style: italic !important; color: #9a8e7e !important; }',
    '.shopify-section__blog .article-post__content, .shopify-section__blog .article-post__content p { font-size: 1.5rem !important; font-family: "EB Garamond", Georgia, serif !important; line-height: 1.85 !important; color: #2e2a24 !important; }',
    '.shopify-section__blog .article-post__title, .shopify-section__blog .article-post__info h2 { font-size: 1.9rem !important; font-family: "Playfair Display", Georgia, serif !important; font-weight: 700 !important; font-style: italic !important; text-transform: none !important; color: #0f0c09 !important; }',
    '.shopify-section__blog .article-post__title a, .shopify-section__blog .article-post__info h2 a { font-size: inherit !important; font-family: inherit !important; font-style: italic !important; color: #0f0c09 !important; text-decoration: none !important; text-transform: none !important; }',
    '.shopify-section__blog .abc-mag-read-more { font-size: 1.4rem !important; }',
    '.shopify-section__blog .article-post__footer, .shopify-section__blog .article-post__category, .shopify-section__blog .article-post__categories { display: none !important; }'
  ].join('\n');
  document.head.appendChild(styleTag);

  /* ── 3b. Style article titles ── */
  function styleArticles() {
    blogSection.querySelectorAll('.blog-article').forEach(function (article) {
      article.style.cssText = 'background:#ffffff;border:0.5px solid #d8d0c0;border-radius:4px;overflow:hidden;display:flex;flex-direction:column;';
      var title = article.querySelector('.article-post__title, .article-post__info h2, h2');
      if (title) {
        title.style.cssText = 'font-family:"Playfair Display",Georgia,serif;font-size:1.9rem;font-weight:700;font-style:italic;line-height:1.25;text-transform:none!important;color:#0f0c09;margin:0 0 0.5rem;';
        var link = title.querySelector('a');
        if (link) link.style.cssText = 'color:#0f0c09;text-decoration:none;font-style:italic;';
      }
      var meta = article.querySelector('.article-post__data-wrap');
      if (meta) meta.style.cssText = 'font-family:"EB Garamond",Georgia,serif;font-size:1.4rem;font-style:italic;color:#9a8e7e;margin-bottom:0.6rem;';
      var excerpt = article.querySelector('.article-post__content');
      if (excerpt) {
        excerpt.style.cssText = 'font-family:"EB Garamond",Georgia,serif;font-size:1.5rem;line-height:1.85;color:#2e2a24;';
        excerpt.querySelectorAll('p').forEach(function (p) {
          p.style.cssText = 'font-family:"EB Garamond",Georgia,serif;font-size:1.5rem;line-height:1.85;color:#2e2a24;margin:0;';
        });
      }
      var info = article.querySelector('.article-post__info');
      if (info) info.style.cssText = 'padding:1.1rem 1.3rem 1.3rem;background:transparent;flex:1;display:flex;flex-direction:column;';
      var imgEl = article.querySelector('img');
      if (imgEl) imgEl.style.cssText = 'width:100%;height:auto;display:block;';
      var footer = article.querySelector('.article-post__footer');
      if (footer) footer.style.cssText = 'display:none;';
      var category = article.querySelector('.article-post__category, .article-post__categories');
      if (category) category.style.cssText = 'display:none;';
    });
  }
  styleArticles();

  /* ── 4. Restructure grid: featured + 2-column ── */
  var grid = blogSection.querySelector('.article-grid, .blog-articles');
  var gridArticles = grid ? grid.querySelectorAll('.blog-article') : [];

  if (grid && gridArticles.length > 0) {
    /* Move breadcrumbs to just above the grid */
    var bc = container.querySelector('.abc-mag-breadcrumb-body');
    if (bc) grid.parentNode.insertBefore(bc, grid);

    var featuredLabel = document.createElement('div');
    featuredLabel.className = 'abc-mag-section-label';
    featuredLabel.textContent = 'Latest Content';
    grid.parentNode.insertBefore(featuredLabel, grid);

    var featured = gridArticles[0];
    featured.style.cssText = 'background:#ffffff;border:0.5px solid #d8d0c0;border-radius:4px;overflow:hidden;margin-bottom:2rem;';

    /* Apply the 2-col grid to .article-post so image + info are the two columns */
    var fPost = featured.querySelector('.article-post');
    if (fPost) fPost.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;min-height:320px;';

    var fImgContainer = featured.querySelector('.article-post__image-container, .article-post__image-wrapper');
    if (fImgContainer) fImgContainer.style.cssText = 'overflow:hidden;';
    var fImg = featured.querySelector('img');
    if (fImg) fImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';

    var fInfo = featured.querySelector('.article-post__info');
    if (fInfo) fInfo.style.cssText = 'padding:2rem;display:flex;flex-direction:column;background:transparent;';

    var fTitle = featured.querySelector('.article-post__title, .article-post__info h2');
    if (fTitle) {
      fTitle.style.cssText = 'font-family:"Playfair Display",Georgia,serif;font-size:2rem;font-weight:700;font-style:italic;line-height:1.2;text-transform:none!important;color:#0f0c09;margin:0 0 0.5rem;';
      var fLink = fTitle.querySelector('a');
      if (fLink) fLink.style.cssText = 'color:#0f0c09;text-decoration:none;font-family:"Playfair Display",Georgia,serif;font-style:italic;text-transform:none;';
    }
    var fExcerpt = featured.querySelector('.article-post__content');
    if (fExcerpt) fExcerpt.style.cssText = 'font-family:"EB Garamond",Georgia,serif;font-size:1.15rem;line-height:1.85;color:#2e2a24;';

    /* Add "Read More" link pointing to the article URL */
    if (fInfo) {
      var articleUrl = (fLink && fLink.href) ? fLink.href : '#';
      var existingReadMore = fInfo.querySelector('.abc-mag-read-more');
      if (!existingReadMore) {
        var readMore = document.createElement('a');
        readMore.className = 'abc-mag-read-more';
        readMore.href = articleUrl;
        readMore.textContent = 'Read more';
        readMore.style.cssText = 'display:inline-block;margin-top:auto;padding-top:1.25rem;font-family:"EB Garamond",Georgia,serif;font-size:1.4rem;font-style:italic;color:#7a5c2a;text-decoration:none;border-bottom:1px solid #c9a84c;line-height:1;';
        fInfo.appendChild(readMore);
      }
    }

    grid.parentNode.insertBefore(featured, grid);

    if (gridArticles.length > 1) {
      var moreLabel = document.createElement('div');
      moreLabel.className = 'abc-mag-section-label';
      moreLabel.textContent = 'More stories';
      grid.parentNode.insertBefore(moreLabel, grid);
    }
    grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:1.5rem;';
  }

  /* ── 5. Sidebar styling ── */
  blogSection.querySelectorAll('.blog-sidebar .widget, .blog-sidebar .block').forEach(function (w) {
    w.style.cssText = 'background:#faf8f4;border:0.5px solid #d8d0c0;border-radius:4px;padding:1.2rem 1.4rem;margin-bottom:1.5rem;';
  });
  blogSection.querySelectorAll('.blog-sidebar .block-title, .blog-sidebar .widget-title').forEach(function (t) {
    t.style.cssText = 'font-family:"Playfair Display",Georgia,serif;font-size:0.78rem;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;color:#0f0c09;border-bottom:0.5px solid #c8c0b0;padding-bottom:0.6rem;margin-bottom:0.8rem;';
  });
  blogSection.querySelectorAll('.blog-sidebar a').forEach(function (a) {
    a.style.cssText = 'font-family:"EB Garamond",Georgia,serif;font-size:1rem;color:#3a3630;text-decoration:none;';
  });
});
